<script lang="ts">
    import { Vue, Prop, Component } from 'vue-facing-decorator';

    @Component({ name: 'Separator' })
    export default class Separator extends Vue {
        @Prop({type: String})
        public label?: string;
    }
</script>

<template>
    <div class="a-separator" v-bind:class="{ '-nolabel': !label || label.length === 0 }">
        <div v-if="label && label.length !== 0" class="a-separator__label">{{ label }}</div>
    </div>
</template>
